import { Component, Input } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ParcelAppEntityApplicationRead } from '../../../../../../../openapi';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { CommonModule } from '@angular/common';
import { ParcelsPreviewComponent } from '../../../components/parcels/parcels-preview/parcels-preview.component';

@Component({
  selector: 'app-location-data-preview',
  standalone: true,
  imports: [
    LabelComponent,
    CommonModule,
    ParcelsPreviewComponent
  ],
  templateUrl: './location-data-preview.component.html'
})
export class LocationDataPreviewComponent {
  @Input()
  public application: ApplicationAppEntityApplicationRead | null = null;

  public get parcels(): ParcelAppEntityApplicationRead[] {
    return this.application?.parcels?.filter(v => v?.tag === 'parcels') || [];
  }
}
